import {jsonMember, jsonObject} from "typedjson";

/** Структура пагинации в запросе */

@jsonObject
export class PitRequestCriteriaPage {

  /** Номер страницы. Нумерация начинается с нуля. */
  @jsonMember({name: "pageIndex", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _pageIndex: number;

  /** Количество строк (объектов) на странице */
  @jsonMember({name: "pageSize", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _pageSize: number;


  get pageIndex(): number {
    return this._pageIndex;
  }

  set pageIndex(value: number) {
    this._pageIndex = value;
  }

  get pageSize(): number {
    return this._pageSize;
  }

  set pageSize(value: number) {
    this._pageSize = value;
  }
}
